export const CLICKED_LINK = "Clicked Link";

export const EVENT_NAMES = [
  CLICKED_LINK
];



// WEBPACK FOOTER //
// ./src/constants/eventNames.js